import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useUniqueId } from '../utils/use-unique-id.js';
import { StyledButtonSpinnerContainer, StyledInputWrapper, StyledBaseButtonInput } from './BaseButton.style.js';
import { Spinner } from '../Spinner/Spinner.js';

const BaseButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    ariaControls,
    ariaDescribedby,
    ariaExpanded,
    ariaHaspopup,
    ariaHidden,
    ariaInvalid,
    ariaPressed,
    ariaLabel,
    ariaLabelledby,
    as,
    checked,
    children,
    className,
    disabled,
    inputType,
    loading,
    name,
    onChange,
    onClick,
    type,
    ...rest
  } = _ref;
  const inputId = useUniqueId('input');
  const Component = as || 'button';
  const isLabel = as === 'label';
  const ariaProps = {
    'aria-busy': loading,
    'aria-controls': ariaControls,
    'aria-describedby': ariaDescribedby,
    'aria-haspopup': ariaHaspopup,
    'aria-hidden': ariaHidden,
    'aria-invalid': ariaInvalid,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-pressed': ariaPressed
  };
  const ariaExpandedProp = typeof ariaExpanded === 'boolean' ? ariaExpanded ? 'true' : 'false' : undefined;
  const content = /*#__PURE__*/React__default.createElement(Component, _extends({}, isLabel ? {} : ariaProps, {
    "aria-expanded": ariaExpandedProp,
    className: className,
    disabled: isLabel ? undefined : Component === 'button' && (disabled || loading),
    htmlFor: isLabel ? inputId : undefined,
    onClick: disabled ? undefined : onClick,
    ref: ref,
    type: isLabel ? undefined : type ? type : Component === 'button' ? 'button' : undefined
  }, rest), children, loading && /*#__PURE__*/React__default.createElement(StyledButtonSpinnerContainer, null, /*#__PURE__*/React__default.createElement(Spinner, null)));
  return isLabel ? /*#__PURE__*/React__default.createElement(StyledInputWrapper, null, /*#__PURE__*/React__default.createElement(StyledBaseButtonInput, _extends({}, ariaProps, {
    checked: checked,
    disabled: disabled,
    id: inputId,
    onChange: onChange,
    name: name,
    type: inputType
  })), content) : content;
});

// @ts-expect-error
BaseButton.displayName = 'BaseButton';

export { BaseButton };
